import Vue from 'vue';

import App from '@/framework/App';
import router from '@/framework/router';
import store from '@/framework/store';

import 'normalize.css';

import ElementUI from 'element-ui';
import '@/scss/element-variables.scss';

import '@/scss/index.scss';

import indexPlugin from '@/framework';

import appConfig from '@/constants';

import VueCropper from 'vue-cropper';
Vue.use(VueCropper);

Vue.use(indexPlugin);

Vue.use(ElementUI, {
  size: appConfig.elementUiSize || 'small',
});

Vue.config.productionTip = false;

let core = {
  el: '#app',
  router,
  store,
  // i18n,
  render: (h) => h(App),
};

export default core;
